
















































import VueOptions from '@utils/VueOptions'
import BrandSelector from '@ui/AudienceSetWizard/components/BrandSelector'
import Modal from '@components/Modal'

settings =
  name: 'FormFieldBrandSelect'

  vue:
    props: ['value', 'errors', 'context']

    components: {
      BrandSelector,
      Modal,
    }

    data: ->
      sponsorSet: @value || []
      sponsorSetModal:
        show: false
        sponsor: null

    methods:
      hiAddSponsorSet: ->
        @sponsorSetModal.show = true

      hiCloseSponsorSetModal: ->
        @closeSponsorModal()  

      hiSaveSponsorSetModal: ->
        @sponsorSet.push @sponsorSetModal.sponsor
        @closeSponsorModal()
        @inputChanged()

      hiRemoveSponsorSet: (sponsorSet) ->
        @sponsorSet = @sponsorSet.filter((s) => s.domain isnt sponsorSet.domain)
        @inputChanged()

      closeSponsorModal: ->
        @sponsorSetModal =
          show: false
          sponsor: null

      inputChanged: ->
        @$emit 'input', @sponsorSet
        @$emit 'change', @sponsorSet

    watch:
      value: (value) ->
        @sponsorSet = value

export default VueOptions.vue settings
